import React, { Component } from "react";
import { InputItem, Toast, WhiteSpace, ActionSheet } from "antd-mobile";
import { createForm } from "rc-form";
import { aes } from "lujing-fe-js-encryption";
import {
  getVerificateCode,
  register,
  selectNoSignedContractListForTms,
  recordSpecialAuthAgreement,
  queryThirdPartySystem
} from "../../services/author";
import { getPathParams, throttle } from "../../utils/utils";
import styles from "./index.less";
import unselect from "../../public/unselect.png";
import select from "../../public/select.png";
import SignActionSheet from './contract/signActionSheet'
import { notify } from "./utils";

const law_agreement_title = "法律声明及隐私权政策";
const law_agreement_url = "https://www.lujing56.com/h5/view/p_law.html";
const user_agreement_title = "传化网络货运平台用户服务协议";
const user_agreement_url = "https://www.lujing56.com/h5/view/p_userprotocol.html";

const tms_shouquan_agreement_title = "特别授权协议";
const tms_shouquan_agreement_url = "https://www.lujing56.com/h5/view/tms_shouquan.html";


const isIPhone = new RegExp('\\biPhone\\b|\\biPod\\b', 'i').test(window.navigator.userAgent);
let wrapProps;
if (isIPhone) {
  wrapProps = {
    onTouchStart: e => e.preventDefault(),
  };
}
class Author extends Component {
  state = {
    getParams: getPathParams(this.props.location.search),
    code: "",//验证码
    open: true,
    count: 60,
    thirdPartySystemName: "",
    isSelcted: false,
    unSignedContract: [],//平台模式，未签署的合同列表
  };
  componentDidMount() {
    const obj = getPathParams(this.props.location.search);
    this.setState({
      getParams: obj
    });
    this.queryThirdParty(obj);
    // 查询合同是否签订
    this.selectNoSignContractList(obj);
  }

  // 查询第三方
  queryThirdParty = (obj) => {
    queryThirdPartySystem({ partyId: obj.partyId, platformCode: obj.platformCode }).then(data => {
      if (data.code === 0) {
        this.setState({
          thirdPartySystemName: data.data && data.data.thirdPartySystemName,
        });
      }
    });
  }

  // 查看授权协议
  handleAgrementContent = () => {
    const { getParams } = this.state;
    if (Number(getParams.platformCode) === 100) {
      this.props.history.push(`/authorAgreement?partyId=${getParams.partyId || ""}&platformCode=100`);
    } else {
      this.props.history.push(`/authorAgreement?partyId=${getParams.partyId || ""}`);
    }
  };

  // 查看验证码
  handleCode = value => {
    this.setState({
      code: value
    });
    sessionStorage.setItem('identifyingCode', value)
  };

  // 处理倒计时
  handleCutTime = () => {
    const { count } = this.state;
    if (count === 1) {
      this.setState({
        count: 60,
        open: true
      });
    } else {
      this.setState({
        count: count - 1,
        open: false
      });
      setTimeout(this.handleCutTime, 1000);
    }
  };

  // 处理点击获取验证码事件
  handleRequireCode = () => {
    const { getParams } = this.state;
    const { open } = this.state;
    if (!open) {
      return;
    }
    getVerificateCode({
      platformCode: getParams.platformCode,
      mobileNumber: getParams.mobile,
    }).then(data => {
      console.log(data);
    });
    this.handleCutTime();
  };

  // 确认授权
  sureAuthor = throttle((title) => {
    const { platformCode } = this.state.getParams;
    // 平台模式
    if (Number(platformCode) === 100 && this.state.unSignedContract.length === 0) {
      sessionStorage.removeItem('actionVisible')
    } else {
      sessionStorage.setItem('actionVisible', true)
    }
    this.recordAgeement(title);
  }, 2000)

  // 协议记录
  recordAgeement = (title) => {
    const { id, mobile, partyId, platformCode, name } = this.state.getParams;
    const { thirdPartySystemName } = this.state;
    let params = {
      platformCode: platformCode,
      thirdPartyId: partyId,
      name: name,
      mobile: aes.encryption(mobile),
      idCardNo: aes.encryption(id),
      agreements: [
        {
          agreementName:tms_shouquan_agreement_title,
          agreementContent: tms_shouquan_agreement_url,
          version: "1.0.3",
        }, {
          agreementName: law_agreement_title,
          agreementContent: law_agreement_url,
          version: "1.0.1",
        }, {
          agreementName: user_agreement_title,
          agreementContent: user_agreement_url,
          version: "1.0.1",
        }
      ]
    };
    recordSpecialAuthAgreement(params).then(res => {
      if (res.code === 0) {
        //协议记录成功才能发起授权
        this.authClick(title);
      } else {
        sessionStorage.removeItem('actionVisible')
        Toast.fail(res.msg);
      }
    });
  }

  //发起授权
  authClick = async (title) => {
    const { getParams, code, unSignedContract } = this.state;
    const { id, mobile, partyId, platformCode, ownerPartyId, name } = getParams;
    if (!code) {
      sessionStorage.removeItem('actionVisible')
      Toast.fail('请输入验证码');
      return
    }
    let params = {
      platformCode,
      idCard: aes.encryption(id),
      mobileNumber: aes.encryption(mobile),
      userName: name,
      identifyingCode: code,
      ownerPartyId: Number(platformCode) === 100 ? ownerPartyId : partyId,
      operatorId: Number(platformCode) === 100 ? partyId : null,
    };
    // 平台模式下，若查询未签署协议为空，则不调用注册接口，打开协议确认弹窗
    if (Number(platformCode) === 100) {
      const obj = getPathParams(this.props.location.search);
      params = {
        ...this.props,
        ...params,
        ...obj,
        outUserMobile: mobile,
        driverIdCard: id,
        ownerPartyId: ownerPartyId,
        operatorId: partyId,
        platformCode: platformCode,
        templetUniqueCodes: unSignedContract
      }
      if (unSignedContract.length > 0) {
        console.log('平台模式-----有数据---不注册')
        sessionStorage.setItem('actionVisible', true)
        this.selectNoSignContractList(params, title);
        return;
      }
    }
    console.log('普通货主模式--------注册接口后在弹窗')
    register({ ...params }).then(async (data) => {
      if (data.code === 0) {
        const obj = getPathParams(this.props.location.search);
        if (Number(platformCode) === 100) {
          Toast.success(data.data)
          let backUrl = obj.backUrl || '';
          let sourceEnv = obj.sourceEnv || null;
          notify(true, sourceEnv, backUrl);
          return;
        }
        params = {
          ...this.props,
          ...params,
          ...obj,
          outUserMobile: mobile,
          driverIdCard: id,
        }

        // 已授权，但未签订协议情形会返回加密key
        if (data.data && data.data.length > 0) {
          params = {
            ...params,
            ownerPartyId: partyId,
            rowKey: data.data
          }
        }
        // 平台模式
        if (Number(platformCode) === 100) {
          params = {
            ...params,
            ownerPartyId: ownerPartyId,
            operatorId: partyId,
            platformCode: platformCode,
          }
        }
        this.selectNoSignContractList(params, title)
      } else {
        sessionStorage.removeItem('actionVisible')
        Toast.fail(data.msg);
      }
    });
  }

  //查询未签订协议
  selectNoSignContractList(obj, title) {
    const { ownerPartyId, outUserMobile = '', driverIdCard = '', platformCode, partyId, id } = obj;
    const operatorId = Number(platformCode) === 100 ? partyId : null
    const mobile = (outUserMobile || obj.mobile).toString();
    const card = (driverIdCard || id).toString();
    let params = {
      platformCode,
      operatorId,
      ownerPartyId,
      outUserMobile: aes.encryption(mobile), //aes.encryption(outUserMobile),
      driverIdCard: aes.encryption(card),//aes.encryption(card),
    }
    selectNoSignedContractListForTms(params).then(data => {
      const contractDetail = data.data;
      this.setState({
        unSignedContract: []
      })
      if (data.code === 0 && contractDetail) {
        if (Number(platformCode) === 100) {//平台模式
          //平台模式，确认授权和同意签署协议共用接口，本期T3.6.2更换新接口
          const codes = []; //未签署的合同模板码
          contractDetail.forEach((i) => {
            const { contractList } = i;
            contractList.forEach((j) => {
              codes.push(j.contractTemplateCode);
            });
          });
          this.setState({
            unSignedContract: codes
          })
          if (codes.length > 0) {
            let values = {
              ...this.props,
              contractDetail,
              ...obj,
              ...params
            }
            console.log('values-------------', values)
            // 如果是协议详情返回 或者点击确认授权按钮
            if (sessionStorage.getItem('actionVisible')) {
              const BUTTONS = [<SignActionSheet {...values} />];
              ActionSheet.showActionSheetWithOptions({
                options: BUTTONS,
                cancelButtonIndex: BUTTONS.length - 1,
                destructiveButtonIndex: BUTTONS.length - 2,
                // title: 'title',
                message: <div className="topTitleBox">
                  <div className="topTitle">请阅读并确认以下协议</div>
                  <div className="topContent">在开展业务前请您仔细阅读并确认《下游运输供应商》，《运费支付确认书》的合同协议内容，点击同意后，开始承接业务。感谢您使用传化网络货运业务模块！</div>
                </div>,
                maskClosable: true,
                'data-seed': 'logId',
                wrapProps,
                className: styles.modalXY
              })
            }
          } else {
            sessionStorage.removeItem('actionVisible')
          }
        } else {
          // 已签订合同直接跳转结果页
          if (contractDetail.templates && contractDetail.templates.length === 0) {
            Toast.success('签订成功')
            // this.props.history.replace("/result?id=1");
            // 如果已经从别的途径预先签订过协议，则直接跳转结果页
          } else if (contractDetail && contractDetail.length == 0 && title) {
            Toast.success('签订成功')
            // this.props.history.replace("/result?id=1");
          } else if (contractDetail && contractDetail.length > 0) {
            // 司机partyId
            let driverPartyId = contractDetail[0].toPartyId;
            let values = {
              ...this.props,
              contractDetail,
              driverPartyId,
              ...obj,
              ...params
            }
            // 如果是协议详情返回 或者点击确认授权按钮
            if (sessionStorage.getItem('actionVisible')) {
              const BUTTONS = [<SignActionSheet {...values} />];
              ActionSheet.showActionSheetWithOptions({
                options: BUTTONS,
                cancelButtonIndex: BUTTONS.length - 1,
                destructiveButtonIndex: BUTTONS.length - 2,
                // title: 'title',
                message: <div className="topTitleBox">
                  <div className="topTitle">请阅读并确认以下协议</div>
                  <div className="topContent">在开展业务前请您仔细阅读并确认《下游运输供应商》，《运费支付确认书》的合同协议内容，点击同意后，开始承接业务。感谢您使用传化网络货运业务模块！</div>
                </div>,
                maskClosable: true,
                'data-seed': 'logId',
                wrapProps,
                className: styles.modalXY
              })
            }
          }
        }

      } else {
        sessionStorage.removeItem('actionVisible')
        if (data.msg !== '司机不存在') {
          Toast.fail(data.msg);
        }
      }
    });
  }


  //勾选同意
  agreeClick = (e) => {
    const { isSelcted } = this.state;
    this.setState({
      isSelcted: !isSelcted,
    })
  }

  render() {
    const getParams = getPathParams(this.props.location.search);
    const { open, code, count, isSelcted } = this.state;
    const sfz = getParams.id ? getParams.id : "";
    const node = (
      <div>
        {open ? (
          <div className={styles.verificationCode} onClick={this.handleRequireCode}>获取验证码</div>
        ) : (
          <div className={styles.verificationCodeGray}>{count}后重新获取</div>
        )}
      </div>
    );
    return (
      <div className={styles.bgView}>
        <div className={styles.contentContainer}>
          <div className={styles.contentBg}>
            <div className={styles.contentBgTitle}>获取授权</div>
            <div className={styles.contentBgText}>获取验证码授权后即可签署协议</div>
          </div>
          <div className={styles.contentBox}>
            <div className={styles.contentTop1}>
              <div className={styles.content}>
                <InputItem value={getParams.name} disabled>真实姓名</InputItem>
              </div>
              <div className={styles.content}>
                <InputItem value={sfz} disabled >身份证号</InputItem>
              </div>
            </div>
            <div className={styles.contentTop2}>
              <div className={styles.content}>
                <InputItem value={getParams.mobile} disabled >手机号</InputItem>
              </div>
              <div className={`${styles.content} ${styles.contentCode}`}>
                <InputItem onChange={this.handleCode} extra={node} placeholder="请输入6位验证码">验证码</InputItem>
              </div>
            </div>
          </div>

        </div>
        <div className={styles.agreementContainer}>
          <div className={styles.agreement}>
            <img className={styles.selctImg} src={isSelcted ? select : unselect} onClick={this.agreeClick} alt=""></img>
            <div className={styles.agreementTitle}>
              勾选即代表同意
              <a className={styles.text} onClick={this.handleAgrementContent}>《特别授权协议》</a>
              <a className={styles.text} href={law_agreement_url}>《{law_agreement_title}》</a>
              <a className={styles.text} href={user_agreement_url}>《{user_agreement_title}》</a>
            </div>
          </div>

          <div onClick={() => this.sureAuthor('确认授权')} className={isSelcted ? styles.btn : styles.unable}>确认授权</div>
          <WhiteSpace />
        </div>
      </div>
    );
  }
}
export default createForm()(Author);



// WEBPACK FOOTER //
// ./src/routes/author/index.js